/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, {useState, useEffect } from "react";

// reactstrap components //https://xs458763.xsrv.jp/api/
import { Card, CardHeader, CardBody, CardTitle, Row, Col, Input } from "reactstrap";
import { useHistory } from 'react-router-dom';
import down from "assets/img/down.png";
import up from "assets/img/up.png";
import { Radar, RadarChart, PolarGrid, 
  PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";

let session = {}; 
let se;

function Analysis1() {
  
  const player = JSON.parse(window.sessionStorage.getItem('player'));

  const history = useHistory();
  const [checkboxgroup, setCheckboxgroup] = useState(
    [ { en: 's_serverData', jp: 'サーブ', fc: 's_setServerData', val:true },
      { en: 's_receiveData', jp: 'レシーブ', fc: 's_setReceiveData', val:true},
      { en: 's_strokeData', jp: 'ストローク', fc: 's_setStrokeData', val:true},
      { en: 's_netplayData', jp: 'ネットプレー', fc: 's_setNetplayData', val:true},
      { en: 's_mentalData', jp: 'メンタル', fc: 's_setMentalData', val:true},
      { en: 's_tacticsData', jp: '戦術', fc: 's_setTacticsData', val:true},]
    );
  
  const [s_serverData, s_setServerData] = useState([]);
  const [s_receiveData, s_setReceiveData] = useState([]);
  const [s_strokeData, s_setStrokeData] = useState([]);
  const [s_netplayData, s_setNetplayData] = useState([]);
  const [s_mentalData, s_setMentalData] = useState([]);
  const [s_tacticsData, s_setTacticsData] = useState([]);
  
  const [powermark, setpowermark] = useState(0);
  const [techmark, settechmark] = useState(0);
  const [physicalmark, setphysicalmark] = useState(0);
  const [titlemark, settitlemark] = useState(0);

  useEffect(() => {
    session = window.sessionStorage.getItem('sessions'); 
    se = JSON.parse(session);

    for(var i = 0 ; i < checkboxgroup.length; i++){

      if(JSON.parse(window.sessionStorage.getItem(checkboxgroup[i]['en'])) != null)
        eval(checkboxgroup[i]['fc'])(JSON.parse(window.sessionStorage.getItem(checkboxgroup[i]['en'])));
      
      axios.get(URL_API+"getSelfSelAPI", {
        params: {
          data: checkboxgroup[i]['en'],
          user: player['id'], 
        }
      })
      .then(function (response) {
        
        if(response.data !== null && response.data.length > 0){           
          
          window.sessionStorage.setItem(response.data[0]['group_id'], JSON.stringify(response.data));

          eval(response.data[0]['fc'])(JSON.parse(window.sessionStorage.getItem(response.data[0]['group_id'])));

        }

      });
    }

    let p = JSON.parse(window.sessionStorage.getItem('power'));
    if(Array.isArray(p)){
      if(p.length > 0){
        setPower(p); 
        let t = p[0]['val1'] + p[0]['val2'] + p[0]['val3'] +p[0]['val4'] +p[0]['val5']+p[0]['val6'];        
        //setTotal(t);
        setpowermark(Math.round(t / 6));
      }
    }
    
    axios.get(URL_API+"rederchart", {
      params: {
        kind: 1,
        user: player['id'], 
      }
    })
    .then(function (response) {
     
      if(Array.isArray(response.data)){
        if(response.data.length > 0){

          power[0]['x'] = response.data[0]['val1'];
          power[1]['x'] = response.data[0]['val2'];
          power[2]['x'] = response.data[0]['val3'];
          power[3]['x'] = response.data[0]['val4'];
          power[4]['x'] = response.data[0]['val5'];
          power[5]['x'] = response.data[0]['val6'];

          let t = response.data[0]['val1'] + response.data[0]['val2'] + response.data[0]['val3'] +response.data[0]['val4'] +response.data[0]['val5']+response.data[0]['val6'];
          setPower(power);
          //setTotal(t);
          setpowermark(Math.round(t / 6));
        }
      }

    });

    p = JSON.parse(window.sessionStorage.getItem('tech'));
    if(Array.isArray(p)){
      if(p.length > 0){
        setTech(p); 
        let t = p[0]['val1'] + p[0]['val2'] + p[0]['val3'] +p[0]['val4'] +p[0]['val5']+p[0]['val6']+p[0]['val7']+p[0]['val8'];        
        //setTotal(t);
        settechmark(Math.round(t / 8));
      }
    }
    
    axios.get(URL_API+"rederchart", {
      params: {
        kind: 2,
        user: player['id'], 
      }
    })
    .then(function (response) {
     
      if(Array.isArray(response.data)){
        if(response.data.length > 0){

          tech[0]['x'] = response.data[0]['val1'];
          tech[1]['x'] = response.data[0]['val2'];
          tech[2]['x'] = response.data[0]['val3'];
          tech[3]['x'] = response.data[0]['val4'];
          tech[4]['x'] = response.data[0]['val5'];
          tech[5]['x'] = response.data[0]['val6'];
          tech[6]['x'] = response.data[0]['val7'];
          tech[7]['x'] = response.data[0]['val8'];

          let t = response.data[0]['val1'] + response.data[0]['val2'] + response.data[0]['val3'] +response.data[0]['val4'] +response.data[0]['val5']+response.data[0]['val6']+response.data[0]['val7']+response.data[0]['val8'];
          setTech(tech);
          //setTotal(t);
          settechmark(Math.round(t / 8));
        }
      }

    });
    
    p = JSON.parse(window.sessionStorage.getItem('physical'));
    if(Array.isArray(p)){
      if(p.length > 0){
        setPhysical(p); 
        let t = p[0]['val1'] + p[0]['val2'] + p[0]['val3'] +p[0]['val4'] +p[0]['val5']+p[0]['val6']+p[0]['val7']+p[0]['val8'];        
        //setTotal(t);
        setphysicalmark(Math.round(t / 8));
      }
    }
    
    axios.get(URL_API+"rederchart", {
      params: {
        kind: 3,
        user: player['id'], 
      }
    })
    .then(function (response) {
     
      if(Array.isArray(response.data)){
        if(response.data.length > 0){

          physical[0]['x'] = response.data[0]['val1'];
          physical[1]['x'] = response.data[0]['val2'];
          physical[2]['x'] = response.data[0]['val3'];
          physical[3]['x'] = response.data[0]['val4'];
          physical[4]['x'] = response.data[0]['val5'];
          physical[5]['x'] = response.data[0]['val6'];
          physical[6]['x'] = response.data[0]['val7'];
          physical[7]['x'] = response.data[0]['val8'];

          let t = response.data[0]['val1'] + response.data[0]['val2'] + response.data[0]['val3'] +response.data[0]['val4'] +response.data[0]['val5']+response.data[0]['val6']+response.data[0]['val7']+response.data[0]['val8'];
          setPhysical(physical);
          //setTotal(t);
          setphysicalmark(Math.round(t / 8));
        }
      }
    });

    p = JSON.parse(window.sessionStorage.getItem('title'));
    if(Array.isArray(p)){
      if(p.length > 0){
        setTitle(p); 
        let t = p[0]['val1'] + p[0]['val2'] + p[0]['val3'] +p[0]['val4'] +p[0]['val5']+p[0]['val6']+p[0]['val7'];        
        //setTotal(t);
        settitlemark(Math.round(t / 7));
      }
    }

    axios.get(URL_API+"rederchart", {
      params: {
        kind: 4,
        user: player['id'], 
      }
    })
    .then(function (response) {
      
      if(Array.isArray(response.data)){
        if(response.data.length > 0){
          console.log(response.data[0]);

          title[0]['x'] = response.data[0]['val1'];
          title[1]['x'] = response.data[0]['val2'];
          title[2]['x'] = response.data[0]['val3'];
          title[3]['x'] = response.data[0]['val4'];
          title[4]['x'] = response.data[0]['val5'];
          title[5]['x'] = response.data[0]['val6'];
          title[6]['x'] = response.data[0]['val7'];         

          let t = response.data[0]['val1'] + response.data[0]['val2'] + response.data[0]['val3'] +response.data[0]['val4'] +response.data[0]['val5']+response.data[0]['val6']+response.data[0]['val7'];
          setTitle(title);
          //setTotal(t);
          settitlemark(Math.round(t / 7));
        }
      }    
    });

  }, []);

  let data = [
    { name: 'メンタル', x: 3 },
    { name: '技術', x: 4 },
    { name: '戦術', x: 4 },
    { name: 'フィジカル', x: 5 },
    { name: '攻撃力', x: 3 },
    { name: '守備カ', x: 4 },
  ];
  const [power, setPower] = useState(data); 

  data = [
    { name: '1stサーブ', x: 3 },
    { name: 'リターン', x: 4 },
    { name: 'ロブ', x: 4 },
    { name: 'ボレー', x: 5 },
    { name: 'スマッシュ', x: 3 },
    { name: 'バック', x: 4 },
    { name: 'フォア', x: 4 },
    { name: '2サーブ', x: 4 },
  ];
  const [tech, setTech] = useState(data); 

  data = [
    { name: 'パワー', x: 3 },
    { name: 'スピード', x: 4 },
    { name: '反応', x: 4 },
    { name: 'バランス', x: 5 },
    // { name: '瞬発力', x: 3 },
    { name: 'フットワーク', x: 3 },
    { name: '持久力', x: 4 },
    { name: '筋力', x: 4 },
    { name: '瞬発力', x: 4 },
  ];
  const [physical, setPhysical] = useState(data);

  // data = [
  //   { name: '集中力', x: 3 },
  //   { name: '冷静さ', x: 4 },
  //   { name: '闘志（空回りしない強気さ）', x: 4 },
  //   { name: 'ポジティブ思考', x: 5 },
  //   { name: 'ボールを最後まで追う', x: 3 },
  //   { name: '声を出せる（打つ時やカモン！）', x: 4 },
  //   { name: '最後まであきらめないポイントへの執着心', x: 4 },   
  // ];
  data = [
    { name: '集中力', x: 3 },
    { name: '冷静さ', x: 4 },
    { name: '闘志', x: 4 },
    { name: 'ホジティブ', x: 5 },
    { name: '追いかける', x: 3 },
    { name: '声', x: 4 },
    { name: '執着心', x: 4 },   
  ];
  const [title, setTitle] = useState(data);

  const redarchart = (e, kind) => {
    // // console.log(kind);
    // if(kind * 1 > 0){

    //   history.push('../sub/redarchart'+kind);

    // }else{

    //   history.push('../sub/redarchart');

    // }

  }

  const [dragPadding0, setDragPadding0] = useState({paddingBottom:'15px'});
  const [dragPadding1, setDragPadding1] = useState({paddingBottom:'15px'});
  const [dragPadding2, setDragPadding2] = useState({paddingBottom:'15px'});
  const [dragPadding3, setDragPadding3] = useState({paddingBottom:'15px'});
  const [dragPadding4, setDragPadding4] = useState({paddingBottom:'15px'});
  const [dragPadding5, setDragPadding5] = useState({paddingBottom:'15px'});
  const [dragPadding6, setDragPadding6] = useState({paddingBottom:'15px'});
  const [dNum, setDNum] = useState(1);

  return (
    <>
      <div className="px-0 mx-0">
        <Row className="px-1 mx-0">
          <Col onClick={(e) => redarchart(e, 0)} style={{textAlign:'center', border:'1px solid #CCC', padding:'5px', margin:'5px', borderRadius:'20px'}}>
            <h6>総合力</h6>
            <div className="d-flex justify-content-center">
              <RadarChart height={150} width={150} style={{fontSize:'10px'}} 
                outerRadius="60%" data={power}>
                <PolarGrid />
                <PolarAngleAxis dataKey="name" />
                <PolarRadiusAxis domain={[0, 5]}/>
                <Radar dataKey="x" stroke="green" angle={1}
                    fill="green" fillOpacity={0.5} max={5} />
              </RadarChart>
            </div>
            <h6 style={{textAlign:'right', paddingRight:'10px'}}>評価 : {powermark}</h6>
          </Col>
          <Col onClick={(e) => redarchart(e, 1)} style={{textAlign:'center', border:'1px solid #CCC', padding:'5px', margin:'5px', borderRadius:'20px'}}>
            <h6>技術</h6>
            <div className="d-flex justify-content-center">
            <RadarChart height={150} width={150}  style={{fontSize:'10px'}} 
              outerRadius="60%" data={tech}>
              <PolarGrid />
              <PolarAngleAxis dataKey="name" />
              <PolarRadiusAxis domain={[0, 5]}/>
              <Radar dataKey="x" stroke="green" angle={1}
                  fill="green" fillOpacity={0.5} max={5} />
            </RadarChart>
            </div>
            <h6 style={{textAlign:'right', paddingRight:'10px'}}>評価 : {techmark}</h6>
          </Col>
          <Col onClick={(e) => redarchart(e, 2)} style={{textAlign:'center', border:'1px solid #CCC', padding:'5px', margin:'5px', borderRadius:'20px'}}>
            <h6>フィジカル</h6>
            <div className="d-flex justify-content-center">
            <RadarChart height={150} width={150}  style={{fontSize:'10px'}} 
              outerRadius="60%" data={physical}>
              <PolarGrid />
              <PolarAngleAxis dataKey="name" />
              <PolarRadiusAxis domain={[0, 5]}/>
              <Radar dataKey="x" stroke="green" angle={1}
                  fill="green" fillOpacity={0.5} max={5} />
            </RadarChart>
            </div>
            <h6 style={{textAlign:'right', paddingRight:'10px'}}>評価 : {physicalmark}</h6>
          </Col>
          <Col onClick={(e) => redarchart(e, 3)} style={{textAlign:'center', border:'1px solid #CCC', padding:'5px', margin:'5px', borderRadius:'20px'}}>
            <h6>メンタル</h6>
            <div className="d-flex justify-content-center">
            <RadarChart height={150} width={150}  style={{fontSize:'10px'}} 
              outerRadius="60%" data={title}>
              <PolarGrid />
              <PolarAngleAxis dataKey="name" />
              <PolarRadiusAxis domain={[0, 5]}/>
              <Radar dataKey="x" stroke="green" angle={1}
                  fill="green" fillOpacity={0.5} max={5} />
            </RadarChart>
            </div>
            <h6 style={{textAlign:'right', paddingRight:'10px'}}>評価 : {titlemark}</h6>
          </Col>
        </Row>

        <Row className="px-1 mx-0 text-left">
          <Col className="col-12 px-1">
            {
              checkboxgroup.map((group, num) =>
              <Card className="demo-icons px-1" key={num}>
                <CardHeader style={{height:'50px'}}>
                  <CardTitle tag="h5">{group.jp}</CardTitle>                
                </CardHeader>
                <CardBody className="all-icons px-1" style={{paddingTop:'0px'}}> 
                  {
                    eval(group.en).map((tmp, index) => (
                      <div className="row px-0 mx-0" key={index}>
                        <div className="col-12 px-0">
                          <div className="row px-0 mx-0" style={{marginTop:'10px'}}>
                            <div className="col-12"> 
                              <h6> 
                                {tmp.item}       
                              </h6>
                            </div> 
                          </div>
                          <div>   
                            <div>                 
                              <Input type="text" 
                                style={{color:'#ff3d02'}}
                                id={"an_"+num+"_" + index}
                                name={"an_"+num}
                                value={tmp.solution}
                                readOnly="readonly" 
                                style={{background:'white'}}
                              />    
                            </div>                           
                          </div>
                        </div>                                           
                      </div>
                    ))
                  }
                </CardBody>
              </Card>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Analysis1;
